var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-form',{staticClass:"mod-form mod-order-form",attrs:{"layout":"horizontal","labelAlign":"left","label-col":_vm.labelCol,"wrapper-col":_vm.wrapperCol,"colon":false,"form":_vm.form},on:{"submit":_vm.onSubmit}},[_c('a-form-item',{attrs:{"wrapper-col":_vm.wrapperColOffset}},[_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("请输入金鹏卡号密码，以完成绑定")])]),_c('a-form-item',{attrs:{"label":"金鹏卡号"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
        'cid',
        {
          initialValue: _vm.cid,
          rules: [
            {
              validator: _vm.handleFieldValidate
            }
          ],
          validateTrigger: 'blur'
        }
      ]),expression:"[\n        'cid',\n        {\n          initialValue: cid,\n          rules: [\n            {\n              validator: handleFieldValidate\n            }\n          ],\n          validateTrigger: 'blur'\n        }\n      ]"}],attrs:{"size":"large","placeholder":"请输入金鹏卡号/手机/身份证号","disabled":!!_vm.cid}})],1),_c('a-form-item',{attrs:{"label":"密码"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
        'loginPwd',
        {
          rules: [
            {
              validator: _vm.handleFieldValidate
            }
          ],
          validateTrigger: 'blur'
        }
      ]),expression:"[\n        'loginPwd',\n        {\n          rules: [\n            {\n              validator: handleFieldValidate\n            }\n          ],\n          validateTrigger: 'blur'\n        }\n      ]"}],attrs:{"size":"large","placeholder":"请输入密码","type":"password"}})],1),_c('a-form-item',{attrs:{"label":"验证码"}},[_c('user-slider-captcha',{ref:"verify",attrs:{"size":"large"},on:{"change":_vm.onCaptchVerify}})],1),_c('a-form-item',{attrs:{"wrapper-col":_vm.wrapperColOffset}},[_c('a-button',{staticStyle:{"margin":"0","width":"100%"},attrs:{"type":"primary","size":"large","loading":_vm.loading,"html-type":"submit"}},[_vm._v("绑定金鹏卡")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }